export const ROAD_TEST = {
    title: "Road Test",
    liveUrl: "https://agentic-eval.vercel.app/" as string | null,
    repositoryUrl: "https://github.com/JarrodSavard/Agentic-Eval",
    video: `${process.env.PUBLIC_URL}/videos/road-test-showcase-captioned-1080p.mp4`,
    poster: `${process.env.PUBLIC_URL}/videos/road-test-poster.jpg`,
    captions: `${process.env.PUBLIC_URL}/videos/road-test-en.vtt`,
};
